import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["expanded", "enableDefaultPadding", "colSpan", "offsetLeft"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect, useRef, useState } from 'react';
import { RESIZE_OBSERVER_SUPPORTED } from '../../../../system/util/compatibility';
export var useTableExpandableSection = function useTableExpandableSection(_ref) {
  var expanded = _ref.expanded,
      enableDefaultPadding = _ref.enableDefaultPadding,
      colSpan = _ref.colSpan,
      offsetLeft = _ref.offsetLeft,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      containerHeight = _useState2[0],
      setContainerHeight = _useState2[1];

  var contentRef = useRef(null);
  useEffect(function () {
    var observer = null;

    if (RESIZE_OBSERVER_SUPPORTED && contentRef.current) {
      observer = new ResizeObserver(function (entries) {
        var contentEntry = entries[0];

        if (!contentEntry) {
          return;
        }

        var contentNodeHeight = contentEntry.target.getBoundingClientRect().height;
        setContainerHeight(contentNodeHeight);
      });
      observer.observe(contentRef.current);
    }

    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  var _useState3 = useState(expanded),
      _useState4 = _slicedToArray(_useState3, 2),
      expandedInternal = _useState4[0],
      setExpandedInternal = _useState4[1];

  useEffect(function () {
    if (expanded) {
      setTimeout(function () {
        return setExpandedInternal(true);
      }, 0);
    } else {
      setExpandedInternal(false);
    }
  }, [expanded]);
  return {
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      enableStickyTop: false,
      enableStickyColumns: false,
      expanded: expanded
    }),
    cellProps: {
      colSpan: colSpan,
      height: containerHeight
    },
    contentProps: {
      expanded: expandedInternal,
      ref: contentRef,
      enableDefaultPadding: enableDefaultPadding,
      offsetLeft: offsetLeft
    }
  };
};